import DataInfo from "../data/DataInfo";
import FieldRelation from '../datamodule/FieldRelation';

const getRelatedInfo = (rel)=> {
    if (!rel) return null;
    if (!/^(\w+)\.(\w+)$/.test(rel)) return null;
    const moduleCode = RegExp.$1;
    const fieldCode = RegExp.$2;
    return {code:moduleCode, field:fieldCode};
}

const randomSort = (datas)=> {
    for (let i = 0; i < datas.length; i++) {
        let j = randomInt(i + 1);
        let t = datas[i];
        datas[i] = datas[j];
        datas[j] = t;
    }
}
const randomInt = (max, min)=> {
    if (!min) min = 0;
    if (!max) max = 4294967295;
    return min + Math.floor(Math.random() * (max - min));
}
const randomInts = (length, max, min)=> {
    if (!min) min = 0;
    if (!max) max = 4294967295;
    const len = max - min;
    if (len < length) return null;
    const values = [];
    if (length < len * 0.3) {
        const map = {};
        for (let i = 0; i < length; i++) {
            let v = randomInt(max, min);
            while (map[v]) {
                v++;
                if (v >= max) v = min;
            }
            map[v] = 1;
            values.push(v);
        }
    } else {
        for (let i = min; i < max; i++) {
            values.push(i);
        }
        randomSort(values);
        values.splice(length);
    }
    return values;
}
// 65-91 97-123
const randomChar = ()=> {
    const i = randomInt(52);
    return String.fromCharCode(i + (i < 26 ? 65 : 71));
}
const randomString = (length)=> {
    if (!length) length = randomInt(10, 3);
    let str = '';
    for (let i = 0; i < length; i++) str += randomChar();
    return str;
}

class DBTable extends DataInfo {
    _datas = [];

    constructor(code, fields, size) {
        const keyFields = [];
        const indexFields = [];
        for (const field of fields) {
            if (field.key) keyFields.push(field.code);
            else if (field.rel) indexFields.push(field.code);
        }
        super(code, {keyField:keyFields.length ? keyFields : null, indexFields:indexFields.length ? indexFields : null});
        this.createRandomDatas(fields, size || 10000);
    }

    size() {
        return this._datas.length;
    }

    // fillKeys(data, keyFields, dataIndex) {
    //     if (keyFields.length > 1) {
    //         for (let i = 0; i < keyFields.length; i++) {
    //             const keyField = keyFields[i];
    //             data[keyField] = 'K' + i + '_' + dataIndex;
    //         }
    //     } else {
    //         data[keyFields[0]] = 'K' + '_' + dataIndex;
    //     }
    // }

    createRandomData(fields) {
        const dataIndex = this._datas.length;
        const data = {};
        for (const field of fields) {
            if (field.key) {
                data[field.code] = 'K_' + dataIndex;
            } else if (field.rel) {
                const relInfo = getRelatedInfo(field.rel);
                if (field.rs == FieldRelation.FR_1vN) {
                    data[field.code] = DB.getRandomKeys(relInfo.code, randomInt(3), relInfo.field);
                } else {
                    data[field.code] = DB.getRandomKey(relInfo.code, relInfo.field);
                }
            } else {
                data[field.code] = randomString();
            }
        }
        this._datas.push(data);
    }

    createRandomDatas(fields, size) {
        this._datas = [];
        for (let i = 0; i < size; i++) {
            this.createRandomData(fields);
        }
        this.resetDatas(this._datas);
    }

    getRandomData() {
        return this._datas[randomInt(this.size())]
    }
    getRandomDatas(count) {
        if (!count) count = 1;
        if (count <= 1) return [this.getRandomData()];
        const size = this.size();
        if (count > size) count = size;
        const indices = randomInts(count, size);
        const datas = [];
        for (const index of indices) datas.push(this._datas[index]);
        return datas;
    }

    getRandomKey(keyField) {
        return this.dataKey(this.getRandomData(), keyField);
    }
    getRandomKeys(count, keyField) {
        const keys = [];
        const datas = this.getRandomDatas(count);
        for (const data of datas) keys.push(this.dataKey(data, keyField));
        return keys;
    }
    dbQueryDatas(queryParams, pagination) {
        const start = pagination ? (pagination.pageNumber - 1) * pagination.pageSize : 0;
        const end = pagination ? start + pagination.pageSize : this._datas.length;
        pagination.total = this._datas.length;
        return {data:this._datas.slice(start, end), pagination:pagination};
    }
    dbQueryAll() {
        return this._datas.slice();
    }
    dbGetDatasByField(field, values) {
        const datas = this.match(field + ' in ' + JSON.stringify(values));
        // console.log('load from test', values, datas);
        return datas;
    }
    dbGetData(key, keyField) {
        return this._dict.getData(key, keyField);
    }
}

class DB {
    static _inst = null;
    static getInstance() {
        if (!DB._inst) DB._inst = new DB();
        return DB._inst;
    }

    static createTable(code, fields, size) {
        return DB.getInstance().createTable(code, fields, size);
    }
    static getTable(code) {
        return DB.getInstance().getTable(code);
    }
    static getRandomKey(code, keyField) {
        return DB.getInstance().getRandomKey(code, keyField);
    }
    static getRandomKeys(code, count, keyField) {
        return DB.getInstance().getRandomKeys(code, count, keyField);
    }
    static queryDatas(code, queryParams, pagination) {
        return DB.getInstance().dbQueryDatas(code, queryParams, pagination);
    }
    static queryAll(code) {
        return DB.getInstance().dbQueryAll(code);
    }
    static getDatasByField(code, field, keys) {
        return DB.getInstance().dbGetDatasByField(code, field, keys);
    }
    static getData(code, key, keyField) {
        return DB.getInstance().dbGetData(code, key, keyField);
    }

    _tableMap = new Map();

    createTable(code, fields, size) {
        const table = new DBTable(code, fields, size);
        this._tableMap.set(code, table);
        return table;
    }
    getTable(code) {
        return this._tableMap.get(code);
    }
    getRandomData(code) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.getRandomData();
    }
    getRandomDatas(code, count) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.getRandomDatas(count);
    }
    getRandomKey(code, keyField) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.getRandomKey(keyField);
    }
    getRandomKeys(code, count, keyField) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.getRandomKeys(count, keyField);
    }
    dbQueryDatas(code, queryParams, pagination) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.dbQueryDatas(queryParams, pagination);
    }
    dbQueryAll(code) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.dbQueryAll();
    }
    dbGetDatasByField(code, field, values) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.dbGetDatasByField(field, values);
    }
    dbGetData(code, key, keyField) {
        const table = this.getTable(code);
        if (!table) return null;
        return table.dbGetData(key, keyField);
    }
}

export default DB;
export { DBTable };